module.exports = (__webpack_require__(8))(1);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/views/View.js from dll-reference girder_lib
// module id = 114
// module chunks = 0